import React from 'react'

export default class Input extends React.Component {

	constructor(props) {
		super(props)
		this.handleChange = this.handleChange.bind(this)
	}

	handleChange(e) {
		this.props.onChange(e.target.name, e.target.value)
	}

	render() {
		const { focus, disabled, label, name, onKeyPress, style, type, value } = this.props
		const className = disabled ? 'capps-input disabled' : 'capps-input'
		return (
			<input
				autoFocus={focus}
				className={className}
				name={name}
				onChange={this.handleChange}
				onKeyPress={onKeyPress}
				placeholder={label}
				style={style}
				type={type}
				value={value}
				disabled={disabled}
			/>
		)
	}

}



// WEBPACK FOOTER //
// ./src/Components/Display/Input.js